import { formatNumber } from '@ab-core/functions/formatting/formatNumber';
import type { Availability } from '@ab-core/graphql/dist';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { AvailabilitiesProps } from '..';
import { CartChannelsWrapper } from './styled';

type CartChannelAvailabilityType = Pick<Availability, 'cartChannelAvailability' | 'deliveryFromFactory'> &
    Pick<AvailabilitiesProps, 'quantityUnit'>;

export const CartChannelAvailability: FC<CartChannelAvailabilityType> = (props) => {
    const { cartChannelAvailability, quantityUnit, deliveryFromFactory } = props;

    return (
        <CartChannelsWrapper>
            {!deliveryFromFactory && cartChannelAvailability && (
                <div className="flex-justify-content-space-between">
                    <Text>{`${cartChannelAvailability?.channel?.name}`}</Text>
                    <Text>{`${formatNumber(
                        cartChannelAvailability?.availability?.availableQuantity
                    )} ${quantityUnit}`}</Text>
                </div>
            )}
        </CartChannelsWrapper>
    );
};
